import type {PageRouteConfig} from '@router';

import CustomDealSelectDate from 'modules/Services/PromotionCenter/CustomDeal/SelectDate/SelectDate';

export function createPromotionCenterCustomDealSelectDateRoute(): PageRouteConfig {
  return {
    element: <CustomDealSelectDate />,
    layout: {
      title: 'انتخاب زمان',
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
